import { qlubSessionStorage } from '../../../service/storage/sessionStorage';

const loginForceEnableKey = 'qlub.login.force';

export function setForceEnable(val: boolean) {
    qlubSessionStorage.set(loginForceEnableKey, val ? 'true' : 'false');
}

export function getForceEnable() {
    const v = qlubSessionStorage.get(loginForceEnableKey);
    if (v) {
        return v === 'true';
    }
    return null;
}
